export default function ({ redirect, $auth }) {
  if (!$auth.user.is_org_admin) {
    return redirect({
      path: "/arm",
    })
  }
}
